import { adminHttpClient } from '../../commons/adminHttpClient'
import { ProductClass } from 'domain/benefit/productClass'

const getProductClassDetails = (productClassId: string | undefined): Promise<ProductClass> => {
  return adminHttpClient.get(`/admindashboard/benefitdetails/productclassdetails/${productClassId ?? ''}`)
}

export default getProductClassDetails
